import { gsap } from 'gsap';

import { Elements } from './Elements';
import { ElementsManager } from './ElementsManager';

export enum MediaState {
  IntroVideoPlaying,
  IntroVideoDone,
  PreviewingVideo,
  PreviewingImage,
  GeneratingVideo,
  ActiveClonePreview,
  NothingSelected,
  UploadingImage,
  DeletingImage,
}

type AppState = {
  currentState: MediaState;
  // ... other state properties
};

export class MediaUIManager {
  private state: AppState;

  private buttonCreateClone: HTMLButtonElement;
  private buttonDelete: HTMLButtonElement;
  private buttonActivate: HTMLButtonElement;
  private buttonStep2: HTMLButtonElement;
  private previewCaption: HTMLElement;
  private introVideo: HTMLElement;
  private buttonUploadSecondary: HTMLElement;
  private elementsManager: ElementsManager = new ElementsManager();
  private elements: Elements = new Elements();
  private playIntroButton = this.elements.get('playVideo') as HTMLElement;
  private step2active = false;

  constructor() {
    this.state = {
      currentState: MediaState.PreviewingImage,
      // ... other initial state properties
    };

    // Get references to the buttons
    this.buttonCreateClone = this.elementsManager.elements.buttonCreateClone as HTMLButtonElement;
    this.buttonActivate = this.elements.get('buttonActivate') as HTMLButtonElement;
    this.buttonDelete = this.elementsManager.elements.buttonDelete as HTMLButtonElement;
    this.buttonStep2 = this.elementsManager.elements.buttonStep2 as HTMLButtonElement;
    this.introVideo = this.elementsManager.elements.introVideo as HTMLElement;
    this.buttonUploadSecondary = this.elementsManager.elements.buttonUploadSecondary as HTMLElement;
    this.previewCaption = this.elements.get('previewCaption') as HTMLElement;
    gsap.set(
      [
        this.buttonCreateClone,
        this.buttonDelete,
        this.buttonActivate,
        this.buttonStep2,
        // this.introVideo,
        this.buttonUploadSecondary,
        this.previewCaption,
      ],
      { autoAlpha: 0, scale: 1 }
    );

    this.updateUI();
  }
  public getState(): AppState {
    return this.state;
  }
  setMediaState(newState: MediaState) {
    this.state.currentState = newState;
    this.updateUI();
  }
  setStep2Active(_boolean: boolean) {
    this.step2active = _boolean;
    this.updateUI();
  }
  private setDisplay(element: HTMLElement | null, value: string) {
    if (element) {
      if (value === 'block') {
        gsap.to(element, {
          autoAlpha: 1,
          scale: 1,
          overwrite: true,
          duration: 0.3,
          ease: 'power2.out',
        });
      } else if (value === 'none') {
        gsap.to(element, { autoAlpha: 0, scale: 1, duration: 0.3, ease: 'power2.out' });
      }
    }
  }
  private updateUI() {
    console.log('updateUI');
    // By default, hide all buttons
    this.previewCaption.innerHTML = '';
    this.setDisplay(this.buttonCreateClone, 'none');
    //this.setDisplay(this.introVideo, 'none');
    this.setDisplay(this.buttonDelete, 'none');
    this.setDisplay(this.buttonActivate, 'none');
    if (!this.step2active) {
      this.setDisplay(this.buttonStep2, 'none');
    } else {
      this.setDisplay(this.buttonStep2, 'block');
    }
    //this.setDisplay(this.buttonUploadSecondary, 'none');

    // this.previewImageButton.style.display = 'none';
    // this.generateVideoButton.style.display = 'none';
    // ... hide other buttons

    // Based on the state, show the appropriate button
    switch (this.state.currentState) {
      case MediaState.IntroVideoPlaying:
        //this.introVideo
        this.setDisplay(this.introVideo, 'block');
        this.buttonUploadSecondary.style.display = 'none';
        // this.previewCaption.innerHTML = 'Previewing Clone';
        // this.setDisplay(this.buttonCreateClone, 'none');
        // this.setDisplay(this.buttonDelete, 'block');
        // this.setDisplay(this.buttonActivate, 'block');
        //   this.previewVideoButton.style.display = 'block';
        break;
      case MediaState.IntroVideoDone:
        this.setDisplay(this.introVideo, 'block');
        this.setDisplay(this.playIntroButton, 'block');

        this.playIntroButton.style.display = 'block';
        this.buttonUploadSecondary.style.display = 'block';

        // this.previewCaption.innerHTML = 'Previewing Clone';
        // this.setDisplay(this.buttonCreateClone, 'none');
        // this.setDisplay(this.buttonDelete, 'block');
        // this.setDisplay(this.buttonActivate, 'block');
        //   this.previewVideoButton.style.display = 'block';
        break;
      case MediaState.PreviewingVideo:
        this.previewCaption.innerHTML = 'Previewing Clone';
        this.setDisplay(this.buttonCreateClone, 'none');
        this.setDisplay(this.buttonDelete, 'block');
        this.setDisplay(this.buttonActivate, 'block');
        this.buttonUploadSecondary.style.display = 'block';
        //   this.previewVideoButton.style.display = 'block';
        break;
      case MediaState.PreviewingImage:
        this.setDisplay(this.buttonCreateClone, 'block');
        this.setDisplay(this.buttonDelete, 'block');
        this.setDisplay(this.buttonActivate, 'none');
        //   this.previewImageButton.style.display = 'block';
        break;
      case MediaState.ActiveClonePreview:
        this.previewCaption.innerHTML = 'This is your activated master clone';
        this.setDisplay(this.buttonCreateClone, 'none');
        this.setDisplay(this.buttonDelete, 'block');
        this.setDisplay(this.buttonActivate, 'none');
        this.setDisplay(this.buttonStep2, 'block');
        //   this.previewImageButton.style.display = 'block';
        break;
      case MediaState.NothingSelected:
        console.log('NothingSelected');
        this.previewCaption.innerHTML = 'Upload an image to get started';
        this.setDisplay(this.buttonCreateClone, 'none');
        this.setDisplay(this.buttonDelete, 'none');
        this.setDisplay(this.buttonActivate, 'none');
        this.setDisplay(this.buttonStep2, 'none');
        this.setDisplay(this.introVideo, 'block');
        this.setDisplay(this.buttonUploadSecondary, 'block');
        //   this.previewImageButton.style.display = 'block';
        break;
      case MediaState.GeneratingVideo:
        //   this.generateVideoButton.style.display = 'block';
        break;
      // ... other cases
    }
  }
}
